import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/dashboard/customers')({
  component: CustomersLayout,
})

function CustomersLayout() {
  return <Outlet />
}
